import React from "react";
import "./faqs.css";
import QuestionsTab from "./QuestionsTab";

function FAQs() {
  return (
    <div className="faq-wrapper">
      <div className="faq-heading">
        In case you feel lost,
        <span style={{ color: "#6D2FEC", paddingLeft: ".5rem" }}>
          {" "}
          We’re here
        </span>
      </div>
      <div className="faq-questions-tab">
        <QuestionsTab
          ques={"How can TamperProof help with document verification?"}
          ans={
            "If a PDF has been altered, TamperProof will catch it. From hidden edits and forged text to metadata changes, it gives you peace of mind that every document you rely on is genuine."
          }
        />
        <QuestionsTab
          ques={"What is Finnalyzer used for?"}
          ans={
            "Finnalyzer takes the hassle out of bank statement analysis. It quickly turns savings and current account data into clear AI insights, helping lenders and finance teams spot risks and make confident decisions."
          }
        />
        <QuestionsTab
          ques={"How is Trustiify’s identity score calculated?"}
          ans={
            "Trustiify looks at verified digital signals: network presence, UPI activity, occupation details, and profile checks to create a reliable identity score you can count on."
          }
        />
        <QuestionsTab
          ques={"How does BounceProof reduce email bounces?"}
          ans={
            "BounceProof checks email addresses before you hit send. That means fewer bounces, better sender reputation, and more campaigns landing where they should, in inboxes."
          }
        />
        <QuestionsTab
          ques={"Can OCRProof handle different file formats?"}
          ans={
            "Absolutely. OCRProof works with scanned documents, PDFs, and images, converting them into accurate, structured, and searchable data you can use right away."}
        />
        <QuestionsTab
        ques={"Do I need all BeFiSc products to get started?"}
        ans={"Not at all. Pick the product you need most today like TamperProof, Finnalyzer, or BounceProof and add others whenever your needs grow."}
        />
      </div>
    </div>
  );
}

export default React.memo(FAQs);
